import React, { PropsWithChildren } from "react";
import { ContentPage } from 'components/ContentPage'
import { AnchorProps } from "antd/lib";
import classNames from "classnames";
import { FloatingTOC, TOCItem } from "components/TOC";

const items: TOCItem[] = [
  {
    key: 'intro',
    href: '#intro',
    title: 'Введение',
  },
  {
    key: 'about',
    href: 'about',
    title: 'О платформе',
  },
  {
    key: 'register',
    href: '#register',
    title: '1. Регистрация',
  },
  {
    key: 'login',
    href: '#login',
    title: '2. Авторизация',
  },
  {
    key: 'user-menu',
    href: '#user-menu',
    title: '3. Меню пользователя',
  },
  {
    key: 'lk',
    href: '#lk',
    title: '4. Профиль',
    children: [
      {
        key: 'lk-projects',
        href: '#lk-projects',
        title: <>4.1 Сервис <q>Проекты</q></>,
        alt: '4.1. Сервис"Проекты"',
        children: [
          {
            key: 'part-4-1-1',
            href: '#part-4-1-1',
            title: '4.1.1. Создание нового проекта',
          },
          {
            key: 'part-4-1-2',
            href: '#part-4-1-2',
            title: '4.1.2. Меню управления проектом',
          }
        ]
      },
      {
        key: 'lk-articles',
        href: '#lk-articles',
        title: <>4.2. Сервис <q>Статьи</q></>,
        alt: '4.2. Вкладка "Статьи"',
        children: [
          {
            key: 'lk-article-list',
            href: '#lk-article-list',
            title: '4.2.1. Каталог статей',

          },
          {
            key: 'article-hub',
            href: '#article-hub',
            title: '4.2.2. Информация о статье',
          },
          {
            key: 'part-4-2-3',
            href: '#part-4-2-3',
            title: '4.2.3. Дополнительные файлы',
          },
          {
            key: 'part-4-2-4',
            href: '#part-4-2-4',
            title: '4.2.4. Взаимодействие с редактором',
          }
        ]
      },
      {
        key: 'lk-reviews',
        href: '#lk-reviews',
        title: <>4.3. Сервис <q>Рецензии</q></>,
        alt: '4.3. Сервис "Рецензии"',
      },
      {
        key: 'lk-templates',
        href: '#lk-templates',
        title: <>4.4. Сервис <q>Шаблоны</q></>,
        alt: '4.4. Сервис "Шаблоны"',
      },
      {
        key: 'lk-courses',
        href: '#lk-courses',
        title: <>4.5. Сервис <q>Курсы</q></>,
        alt: '4.5. Сервис "Курсы"',
        children: [
          {
            key: 'part-4-5-1',
            href: '#part-4-5-1',
            title: '4.5.1. Создание курса'
          },
          {
            key: 'part-4-5-2',
            href: '#part-4-5-2',
            title: '4.5.2. Редактирование курса'
          }
        ]
      },
    ]
  },
  {
    key: 'settings',
    href: '#settings',
    title: '5. Настройки',
  },
  {
    key: 'text-editor',
    href: '#text-editor',
    title: '6. Текстовый редактор',
    children: [
      {
        key: 'part-6-1',
        href: '#part-6-1',
        title: '6.1. Справка',
      },
      {
        key: 'part-6-2',
        href: '#part-6-2',
        title: '6.2. Расширения',
      },
      {
        key: 'review-accept-deny',
        href: '#review-accept-deny',
        title: '6.3. Согласие/отказ от рецензирования',
      },
      {
        key: 'part-6-4',
        href: '#part-6-4',
        title: '6.4. Рецензирование',
        children: [
          {
            key: 'text-editor-review-comments-create',
            href: '#text-editor-review-comments-create',
            title: '6.4.1. Создание комментариев'
          },
          {
            key: 'text-editor-review-comments-view',
            href: '#text-editor-review-comments-view',
            title: '6.4.2. Просмотр комментариев'
          },
          {
            key: 'text-editor-review-comments-edits',
            href: '#text-editor-review-comments-edits',
            title: '6.4.3. Правки внутри текста'
          }
        ]
      },
      {
        key: 'editor-collab',
        href: '#editor-collab',
        title: '6.5. Участники проекта',
        children: [
          {
            key: 'part-6-5-1',
            href: '#part-6-5-1',
            title: '6.5.1. Добавление участника',
          },
          {
            key: 'part-6-5-2',
            href: '#part-6-5-2',
            title: '6.5.2. Управление участником',
          },
        ]
      },
      {
        key: 'editor-submit',
        href: '#editor-submit',
        title: '6.6. Отправка статьи',
      },
      {
        key: 'part-6-7',
        href: '#part-6-7',
        title: '6.7. Отправка правок',
      },
      {
        key: 'part-6-8',
        href: '#part-6-8',
        title: '6.8. Отправка комментария (рецензента)',
      }
    ]
  },
  {
    key: 'intellichecker',
    href: '#intellichecker',
    title: '7. IntelliChecker',
    children: [{
      key: 'part-7-1',
      href: '#part-7-1',
      title: '7.1. Расположение на сайте',
    }]
  },

  {
    key: 'notifications',
    href: '#notifications',
    title: '8. Уведомления',
    children: [
      {
        key: 'part-8-1',
        href: '#part-8-1',
        title: '8.1. Центр уведомлений',
      },
      {
        key: 'part-8-2',
        href: '#part-8-2',
        title: '8.2. Отключение уведомлений',
      },
    ]
  },

  {
    key: 'part-9',
    href: '#part-9',
    title: '9. Директория проекта',
    children: [
      {
        key: 'part-9-1',
        href: '#part-9-1',
        title: '9.1. Форматы файлов',
      },
      {
        key: 'part-9-2',
        href: '#part-9-2',
        title: '9.2. Создание файла',
      },
      {
        key: 'part-9-3',
        href: '#part-9-3',
        title: '9.3. Меню управления файлом',
      },
      {
        key: 'review-project',
        href: '#review-project',
        title: '9.4. Проект рецензента',
        children: [{
          key: 'part-9-4-1', href: '#part-9-4-1', title: '9.4.1. Создание файла рецензии'
        }]
      },
      {
        key: 'part-9-5',
        href: '#part-9-5',
        title: '9.5. Проект редактора',
      },
    ]
  },


  {
    key: 'courses',
    href: '#courses',
    title: '10. Курсы',
    children: [
      {
        key: 'part-10-1',
        href: '#part-10-1',
        title: '10.1. Просмотр курса',
      },
      {
        key: 'part-10-2',
        href: '#part-10-2',
        title: '10.2. Запись на курс',
      },
      {
        key: 'part-10-3',
        href: '#part-10-3',
        title: '10.3. Отмена записи',
      },
    ]
  },

  {
    key: 'journal',
    href: '#journal',
    title: '11. Панель управления журналом',
    children: [
      {
        key: 'article-hub-editor',
        href: '#article-hub-editor',
        title: '11.1. Запрос',
        children: [
          {
            key: 'part-11-1-1',
            href: '#part-11-1-1',
            title: '11.1.1. Управление рецензентами',
          }
        ]
      },
      {
        key: 'part-11-2',
        href: '#part-11-2',
        alt: '11.2. Вкладка "Запросы"',
        title: <>11.2. Вкладка <q>Запросы</q></>,
        children: [
          {
            key: 'part-11-2-1',
            href: '#part-11-2-1',
            title: '11.2.1. Сортировка запросов',
          }
        ]
      },
      {
        key: 'part-11-3',
        href: '#part-11-3',
        alt: '11.3. Вкладка "Архив"',
        title: <>11.3. Вкладка <q>Архив</q></>,
      },
      {
        key: 'part-11-4',
        href: '#part-11-4',
        alt: '11.3. Вкладка "Настройки"',
        title: <>11.4. Вкладка <q>Настройки</q></>,
      },

    ]
  },
]

function Figure({ width = '70%', height = 'auto', src, alt, border = true, children }: PropsWithChildren<{
  width?: string | number | 'auto';
  height?: string | number | 'auto';
  src: string;
  alt?: string;
  border?: boolean
}>) {
  return <figure>
    <img src={src} alt={alt} style={{ height, width }} className={classNames("mx-auto", { 'border border-light-grey rounded-lg': !!border })} />
    {children && <figcaption className="text-center text-black">{children}</figcaption>}
  </figure>
}

export function Step({ n, children }: PropsWithChildren<{ n: number }>) {
  return <p><b>Шаг {n}</b>. {children}</p>
}

export default function UserGuide() {
  return <ContentPage className={classNames(
    "prose-h1:text-center prose-h1:text-4xl",
    "prose-h2:text-center prose-h2:text-3xl",
    "prose-h3:text-center prose-h3:text-2xl",
    "prose-h4:text-center prose-h4:text-lg",
    'prose-h5:font-semibold',
    "marker:text-black",
  )} style={{ quotes: '"«" "»"' }}>
    <FloatingTOC items={items} />
    <h1>Руководство пользователя платформы Research&nbsp;Helper</h1>

    <h2 id="intro">Введение</h2>
    <p>Добро пожаловать в руководство пользователя проекта Research Helper. Здесь Вы можете найти всю необходимую информацию об использовании нашей платформе.</p>
    <p><i>Вы также можете найти наше руководство в формате PDF, по <a href="/static/guide-v3.pdf">этой</a> ссылке</i></p>

    <h2 id="about">О платформе</h2>
    <p><a href="/" target="_blank"><b>Research Helper</b></a> - это платформа для подготовки научных статей, их рецензирования, подачи в журналы и публикации.</p>
    <p>Создавайте проекты статей, приглашайте соавторов для совместной работы, используйте ИИ-ассистента платформы для помощи в перефразировании текста, проверяйте статьи на соответствие редакционным требованиям и отправляйте их для публикации в одно касание.</p>
    <p>Для редакторов и рецензентов на платформе работают сервисы взаимодействия с авторами.</p>


    <h2 id="register">1. Регистрация</h2>
    <p><b>Шаг 1.</b> Нажмите на кнопку <a href="/register" target="_blank"><q>Регистрация</q></a> на навигационной панели (в правом верхнем углу страницы)</p>
    <p><b>Шаг 2.</b> Заполните регистрационную форму</p>

    <Figure src="/images/user-guide/register.png" width="50%" border>
      Форма для регистрации
    </Figure>
    <p>Обязательны для заполнения: <q>Имя</q>, <q>Фамилия</q>, <q>Имя пользователя</q>, <q>E-mail</q>{' '}
      и <q>Пароль</q>.</p>

    <h2 id="login">2. Авторизация</h2>

    <p>Перед началом работы в системе требуется авторизоваться.</p>

    <Step n={1}>
      Перейдите на страницу <a href="/login" target="_blank"><q>Вход</q></a>, используя кнопку <q>Войти</q> на навигационной панели (в верхнем правом углу страницы).
    </Step>
    <Figure src="/images/user-guide/mainpage-signin.png" border>
      Кнопка <q>Войти</q>
    </Figure>

    <Step n={2}>
      Введите имя пользователя и пароль, которые Вы установили при регистрации.
    </Step>

    <h2 id="user-menu">3. Меню пользователя</h2>

    <p>Для открытия меню пользователя, нажмите на аватар (фото) пользователя на навигационной панели (в&nbsp;правом верхнем углу страницы).</p>

    <Figure src="/images/user-guide/user-mainpage.png" border>
      Местонахождение меню пользователя
    </Figure>
    <Figure src="/images/user-guide/user-menu-focused.png" width="300px" border>
      Меню пользователя
    </Figure>
    <p>Меню пользователя содержит вкладки:</p>
    <ul>
      <li><b><q>Профиль</q></b> &mdash; ваши персональные данные и рабочее пространство на платформе</li>
      <li><b><q>Мессенджер</q></b> &mdash; сервис быстрого общения с другими пользователями платформы </li>
      <li><b><q>Настройки</q></b> &mdash; инструмент управления вашими персональными данными</li>
      <li><b><q>Что нового</q></b> &mdash; уведомления об изменениях на платформе</li>
      <li><b><q>Выйти</q></b> &mdash; выход из аккаунта</li>
    </ul>

    <h2 id="lk">4. Профиль</h2>

    <p>Профиль открывается из <a href="#user-menu">Меню пользователя</a>.</p>
    <p>Профиль состоит из двух частей:</p>
    <ul>
      <li><b>Персональная информация</b> &mdash; данные о Вас как об авторе и пользователе платформы.</li>
      <li><b>Рабочее пространство</b> &mdash; инструменты для работы со статьями, взаимодействия с соавторами и рецензентами.</li>
    </ul>

    <p>Раздел персональной информации включает сведения, внесенные вами при регистрации, а также счетчик статей и рецензий.</p>

    <Figure src="/images/user-guide/lk-info.png" width="300px" border>
      Профиль пользователя
    </Figure>

    <p>В рабочем пространстве профиля вы можете пользоваться сервисами:</p>
    <ul>
      <li><b><q>Проекты</q></b> &mdash; сервис для подготовки статей</li>
      <li><b><q>Статьи</q></b> &mdash; каталог статей и мессенджер для взаимодействия с редактором</li>
      <li><b><q>Рецензии</q></b> &mdash; управление рецензированием статьи</li>
      <li><b><q>Шаблоны</q></b> &mdash; сервис создания шаблонов рецензий </li>
      <li><b><q>Курсы</q></b> &mdash; сервис создания и публикации на платформе авторских курсов*</li>
    </ul>

    <small>*Этот сервис доступен только редакторам и администраторам системы.</small>

    <Figure src="/images/user-guide/lk-tabs.png" width="80%" border>
      Сервисы в рабочем пространстве профиля
    </Figure>

    <h3 id="lk-projects">4.1. Сервис <q>Проекты</q></h3>

    <p>Сервис <q>Проекты</q> предназначен для загрузки ваших рабочих файлов, создания проектов статей и отправки статей в журналы.</p>

    <Figure src="/images/user-guide/lk-projects.png" border>
      Профиль &mdash; сервис <q>Проекты</q>
    </Figure>

    <h4 id="part-4-1-1">4.1.1. Создание нового проекта</h4>

    <p>Вы можете сами создать проект или стать участником совместного проекта по приглашению другого пользователя платформы.</p>
    <p>Для создания своего проекта:</p>
    <Step n={1}>Нажмите на кнопку <q>Создать</q></Step>
    <Step n={2}>Укажите название и описание проекта в открывшемся окне</Step>


    <Figure src="/images/user-guide/lk-projects-create-v2.png" width="50%" border>
      Окно создания проекта
    </Figure>

    <p>Если вас пригласили стать участником совместного проекта, вы увидите его в каталоге проектов.</p>
    <Figure src="/images/user-guide/lk-projects-member.png" width="70%" border>
      Каталог проектов с указанием статуса: в созданном проекте автор - владелец, в чужих проектах - участник
    </Figure>

    <p>Вы можете отказаться от участия в совместном проекте, выбрав опцию <q>Покинуть</q> проект.</p>

    <Figure src="/images/user-guide/lk-projects-leave.png" width="70%" border>
      Опция <q>Покинуть</q> в совместном проекте
    </Figure>


    <h4 id="part-4-1-2">4.1.2. Меню управления проектом</h4>

    <p>Меню управления проектом позволяет удалять и переименовывать проект. Чтобы открыть меню, нажмите на кнопку напротив названия проекта.</p>

    <Figure src="/images/user-guide/lk-projects-menu.png" width="70%" border>
      Меню управления проектом
    </Figure>

    <h4 id="part-4-1-3">4.1.3. Работа с проектом</h4>

    <p>Подготовьте статьи для публикации с помощью сервиса <q>Проекты</q>.</p>

    <Step n={1}>Откройте проект &mdash; нажмите на его название.</Step>

    <Figure src="/images/user-guide/lk-projects-title.png" width="50%" border>
      Название проекта
    </Figure>

    <Step n={2}>Создавайте файлы с проектом статьи &mdash; нажмите кнопку <q>Новый файл</q>.</Step>


    <Figure src="/images/user-guide/project-file-create-v2.png" width="70%" border>
      Создание нового файла проекта
    </Figure>

    <p>Выберите подходящий способ создания нового файла, например, загрузите файл со своего компьютера или откройте пустой документ в текстовом редакторе или в формате электронной таблицы.</p>
    <p><a href="#text-editor">Текстовый редактор</a> платформы позволяет писать, редактировать текст, приглашать других участников к совместной работе, отправлять готовую статью в журнал. В редактор встроен ИИ-ассистент с функцией перефразирования текста.</p>
    <p>Редактор таблиц кроме функций работы с электронными таблицами позволяет приглашать к совместной работе других пользователей платформы.</p>
    <p>Опция <q>Выбрать образец</q> даёт возможность загрузить шаблон оформления статьи конкретного журнала.</p>


    <Figure src="/images/user-guide/project-file-sample.png" width="70%" border>
      Создание файла проекта по образцу из журнала
    </Figure>

    <p>Каталог файлов проекта можно упорядочить, отсортировав файлы по имени. Закрепленные файлы всегда остаются сверху.</p>

    <Figure src="/images/user-guide/project-file-menu-and-pin.png" width="70%" border>
      Каталог файлов проекта
    </Figure>

    <h3 id="lk-articles">4.2. Сервис <q>Статьи</q></h3>
    {/* TODO: replace &mdash; with &mdash; */}
    <p>Сервис <q>Статьи</q> позволяет работать со статьями, которые вы подавали в журналы платформы. Как направить статью в журнал, вы можете узнать в разделе <a href="#editor-submit"><q>Текстовый редактор &mdash; Отправка статьи</q></a>.</p>

    <Figure src="/images/user-guide/lk-articles.png" border>
      Профиль &mdash; сервис <q>Статьи</q>
    </Figure>


    <h4 id="lk-articles-list">4.2.1. Каталог статей</h4>

    <p>По умолчанию статьи сортируются по дате создания. Изменить порядок Вы можете нажав на значок рядом со строкой поиска.</p>

    <Figure src="/images/user-guide/lk-articles-sort.png" border>
      Управление сортировкой статей
    </Figure>

    <h4 id="article-hub">4.2.2. Информация о статье</h4>
    <p>Для получения подробной информации о статье, нажмите на название статьи.</p>
    <Figure src="/images/user-guide/lk-articles-open.png" border>
      Название статьи
    </Figure>

    <p>В каталоге доступна следующая информация о статье:</p>
    <ol>
      <li>Номер, название, описание и ключевые слова статьи</li>
      <li>Авторы статьи</li>
      <li>Текущий статус статьи (<q>На рассмотрении</q>, <q>Запрошены изменения</q>, <q>Одобрена</q> или <q>Отказано&nbsp;в&nbsp;рассмотрении</q>)</li>
      <li>Список дополнительных файлов</li>
      <li>Ссылка на журнал</li>
      <li>ФИО редактора журнала</li>
      <li>История действий над статьей (отправка правок, изменение статуса, комментарий рецензента, архивация). Изменение статуса сопровождаются <a href="#notifications">уведомлением</a>.</li>
    </ol>

    <Figure src="/images/user-guide/articlehub.png" width="90%" border>
      Информация о статье для автора
    </Figure>

    <p>При нажатии на название статьи в этом окне, открывается для просмотра файл рукописи, поданный на экспертизу. Чтобы изменить статью или отправить ее в журнал повторно перенесите файл статьи в раздел <q>Проекты</q>.</p>

    <Figure src="/images/user-guide/articlehub-title.png" width="50%" border>
      Название статьи
    </Figure>

    <h4 id="part-4-2-3">4.2.3. Дополнительные файлы</h4>

    <p>В этом разделе отображаются приложенные к статье файлы. Каждый файл содержит: значок типа файла (DOCX, XLSX, PNG, JPEG), его название, а также кнопки:</p>
    <ol>
      <li>Открыть файл (файл открывается в новой вкладке браузера)</li>
      <li>Скачать файл</li>
      <li>Удалить файл</li>
    </ol>
    <Figure src="/images/user-guide/articlehub-addfiles.png">
      Дополнительные файлы
    </Figure>
    <p>При нажатии <b><q>Добавить/Загрузить</q></b>, откроется суб-окно для загрузки, а также выбора файлов (из уже загруженных в исходную директорию рукописи).</p>

    <h4 id="part-4-2-4">4.2.4. Взаимодействие с редактором</h4>

    <p>Вы можете задать вопрос редактору, управляющему экспертизой вашей статьи. Нажмите на значок сообщения рядом с фамилией редактора, откроется мессенджер для переписки с редактором.</p>
    <Figure src="/images/user-guide/articlehub-editor-chat.png" width="100%" border>
      Значок сообщения для переписки с редактором в окне статьи
    </Figure>

    <p>В открывшемся мессенджере Вы можете общаться с редактором в режиме чата.</p>
    <Figure src="/images/user-guide/editor-chat.png" width="100%" border>
      Окно мессенджера для переписки с редактором
    </Figure>




    <h3 id="lk-reviews">4.3. Сервис <q>Рецензии</q></h3>

    <p>Во вкладке <q>Рецензии</q> представлены запросы на рецензирование. Каждый из запросов представляет собой карточку, содержащую следующие элементы:</p>

    <ol>
      <li>Название статьи (при нажатии - открывается <a href="#review-project">проект рецензента</a>)</li>
      <li>Срок</li>
      <li>Дату назначения</li>
      <li>Кнопку <q>Согласиться на рецензирование</q></li>
      <li>Кнопку <q>Отказаться от рецензирования</q></li>
    </ol>

    <p><b>Примечение:</b> до выбора опции <q>Согласиться на рецензирование</q> файл статьи и файл рецензии в <a href="#review-project">проекте рецензента</a> будет доступен только для чтения.</p>

    <Figure src="/images/user-guide/lk-reviews.png">
      Личный кабинет &mdash; вкладка <q>Рецензии</q>
    </Figure>

    <h3 id="lk-templates">4.4. Сервис <q>Шаблоны</q></h3>

    <p>Во вкладке <q>Шаблоны</q> представлены шаблоны, которые Вы загрузили в систему.</p>

    <Figure src="/images/user-guide/templates.png">
      Личный кабинет &mdash; вкладка <q>Шаблоны</q>
    </Figure>

    <p>При нажатии на название шаблона открывается текстовый редактор, позволяющий редактировать содержание выбранного шаблона.</p>


    <h3 id="lk-courses">4.5. Сервис <q>Курсы</q></h3>
    <p>Во вкладке <q>Курсы</q> отображаются созданные Вами курсы.</p>
    <p><i><b>Эта вкладка доступна только редакторам или администраторам системы.</b></i></p>

    <Figure src="/images/user-guide/lk-courses.png">
      Личный кабинет &mdash; вкладка <q>Курсы</q>
    </Figure>

    <h4 id="part-4-5-1">4.5.1. Создание курса</h4>

    <Step n={1}>Нажмите <q>Создать</q></Step>
    <Step n={2}>Введите:</Step>
    <ul>
      <li>Название</li>
      <li>Описание</li>
      <li>Место проведения/ссылку</li>
      <li>Время начала мероприятия</li>
      <li>Время конца мероприятия</li>
      <li>Автора</li>
      <li>Биографию автора</li>
      <li>Наполнение (в виде разделов)</li>
    </ul>

    <h4 id="part-4-5-2">4.5.2. Редактирование курса</h4>

    <p>Для редактирования курса &mdash; нажмите на его название.
      Форма редактирования курса дублирует функционал и наполнение формы для создания курса.</p>

    <h2 id="settings">5. Настройки</h2>

    <p>Настройки позволяют управлять информацией в профиле, уведомлениями, а также паролем аккаунта.
      Для открытия настроек &mdash; откройте <a href="#user-menu">Меню пользователя</a> и выберите позицию <q>Настройки</q></p>

    <Figure src="/images/user-guide/settings.png">
      Настройки пользователя
    </Figure>


    <h2 id="text-editor">6. Текстовый редактор</h2>

    <h3 id="part-6-1">6.1. Справка</h3>
    <Step n={1}>Выберите позицию <q>Файл</q> из списка вкладок</Step>

    <Figure src="/images/user-guide/editor-file.png" width="80%">
      Местонахождение вкладки <q>Файл</q>
    </Figure>

    <Step n={2}>Выберите позицию <q>Справка</q></Step>

    <Figure src="/images/user-guide/editor-help.png" width="80%">
      Вкладка <q>Файл</q>
    </Figure>

    <h3 id="part-6-2">6.2. Расширения</h3>

    <p>В редакторе доступны следующие расширения</p>
    <ul>
      <li>Внешний поиск &mdash; позволяет искать по библиотекам <a href="https://prevmed.elpub.ru/" target="_blank" rel="noreferrer"><q>Терапия без границ</q></a>, <a href="https://pubmed.ncbi.nlm.nih.gov/" target="_blank" rel="noreferrer">PubMed</a>,{' '}
        <a href="https://mendeley.com" target="_blank" rel="noreferrer">Mendeley</a></li>
      <li>Перефразирование текста &mdash; позволяет перефразировать академический текст</li>
      <li>Фоторедактор</li>
      <li>Распознание текста</li>
      <li>Подсчет слов</li>
      <li>Голосовой ввод</li>
    </ul>
    <p>Для их использования &mdash; откройте вкладку <q>Плагины</q> и нажмите на значок расширения.</p>

    <Figure src="/images/user-guide/editor-plugins.png" width="80%">
      Вкладка <q>Плагины</q>
    </Figure>

    <h3 id="review-accept-deny">6.3. Согласие/отказ от рецензирования</h3>
    <p>При отправке рецензии <a href="#review-project">проект рецензента</a> будет доступен только для просмотра.{' '}
      Для получения полного доступа к <a href="#review-project">проекту рецензента</a>  в интерфейсе текстового редактора будут доступны две кнопки:</p>
    <ul>
      <li><q>Согласиться на рецензирование</q></li>
      <li><q>Отказаться от рецензирования</q></li>
    </ul>

    <p>При выборе <q>Отказаться от рецензирования</q> &mdash;  <a href="#review-project">проект рецензента</a> будет удален и доступ к нему будет закрыт.</p>

    {/*TODO: menu on smaller screens*/}

    <Figure src="/images/user-guide/editor-review.png" width="80%">
      Кнопка для согласия/отказа от рецензирования
    </Figure>

    <h3 id="part-6-4">6.4. Рецензирование</h3>
    <p>Для рецензентов текстовый редактор предоставляет два инструмента:</p>
    <ul>
      <li>Комментарии</li>
      <li>Правки внутри текста</li>
    </ul>

    <h4 id="text-editor-review-comments-create">6.4.1. Создание комментариев</h4>
    <Step n={1}>Выберите текст</Step>
    <Step n={2}>Нажмите правую кнопку мыши</Step>
    <Step n={3}>Выберите <q>Добавить комментарий</q></Step>
    <Step n={4}>Введите комментарий и нажмите на клавиатуре клавишу <q>Enter</q></Step>

    <h4 id="text-editor-review-comments-view">6.4.2. Просмотр комментариев</h4>

    <p>Для просмотра комментариев, нажмите на значок комментария в боковой панели редактора (слева).</p>

    <Figure src="/images/user-guide/editor-sidebar-comments.png" width="auto" height="30em">
      Панель комментариев
    </Figure>

    <h4 id="text-editor-review-comments-edits">6.4.3. Правки внутри текста</h4>

    <p>Для создания правки в тексте &mdash; просто начните редактировать документ. В <a href="#review-project">проекте рецензента</a> режим{' '}
      рецензирования включен по умолчанию</p>

    <h3 id="editor-collab">6.5. Участники проекта</h3>

    <p>Для управления участниками проекта, нажмите на кнопку <q>Участники проекта</q> в верхнем правом углу редактора.</p>

    <Figure src="/images/user-guide/editor-collab.png" width="50%">
      Кнопка <q>Участники проекта</q>
    </Figure>

    <p>Далее откроется меню совместного редактирования.</p>
    <Figure src="/images/user-guide/editor-collab-overview.png">
      Меню совместного редактирования
    </Figure>

    <h4 id="part-6-5-1">6.5.1. Добавление участника</h4>
    <p>Для добавления участника &mdash; введите его имя/фамилию/почту в поисковую строку и нажмите на один из результатов</p>
    <Figure src="/images/user-guide/editor-collab-search.png">
      Поиск пользователя
    </Figure>

    <h4 id="part-6-5-2">6.5.2. Управление участником</h4>
    <p>Для управления участником проекта &mdash; нажмите на кнопку напротив его имени.</p>
    <Figure src="/images/user-guide/editor-collab-edit.png">
      Кнопка для управления участником
    </Figure>


    <h3 id="editor-submit">6.6. Отправка статьи</h3>

    <Step n={1}>
      Нажмите на кнопку <q>Отправить статью</q> в верхенм правом углу редактора.
    </Step>

    <Figure src="/images/user-guide/send-article.png">
      Шаг 1 &mdash; кнопка <q>Отправить статью</q>
    </Figure>
    <Step n={2}>
      Найдите или выберите журнал из предоставленных.
    </Step>
    <p><i>Для продолжения нажмите на кнопку <q>Далее</q> внизу окна</i></p>

    <Figure src="/images/user-guide/send-article-1.png">
      Шаг 2 &mdash; выбор журнала
    </Figure>

    <Step n={3}>
      Добавьте участников проекта в метаданные статьи как соавторов. Здесь будут также отображаться сопутствующая информация (текущая организация, e-mail, ORCID, SPIN) из их профилей.
      Для добавления автора в авторский коллектив нажмите на <q>+</q> справа от его карточки. Аналогично Вы можете также нажать на <q>-</q>, если хотите убрать его из соавторов статьи.
    </Step>

    <Figure src="/images/user-guide/send-article-2.png">
      Шаг 3 &mdash; авторский коллектив
    </Figure>

    <Step n={4}>
      Заполните метаданные статьи: название, описание, ключевые слова, язык.
    </Step>
    <p><i>Для продолжения нажмите на кнопку <q>Далее</q> внизу окна</i></p>
    <Figure src="/images/user-guide/send-article-3.png">
      Шаг 4 &mdash; метаданные статьи
    </Figure>
    <Step n={5}>
      Загрузите или выберите дополнительные файлы    </Step>
    <p><i>Для продолжения нажмите на кнопку <q>Далее</q> внизу окна</i></p>
    <Figure src="/images/user-guide/send-article-4.png">
      Шаг 5 &mdash; дополнительные файлы
    </Figure>

    <Step n={6}>
      Подтвердите достоверность данных и отправьте статью в журнал.
    </Step>

    <p><i><b>После отправки данные изменить нельзя, поэтому будьте внимательны.</b></i></p>
    <p>При завершении операции отправки &mdash; будет показано окно <q>В настоящий момент файл недоступен</q>, а также уведомление <q>Заявка отправлена</q>. После этого редактор перезагрузится в режим только для чтения.</p>

    <Figure src="/images/user-guide/send-article-perm-denied.png" width="100%">
      Ошибка <q>Файл недоступен</q>
    </Figure>

    <h3 id="part-6-7">6.7. Отправка правок</h3>

    <p>Для отправки правок у статьи со статусом <q>Запрошены изменения</q> используйте кнопку <q>Отправить правки</q> в правом верхнем углу редактора.</p>

    <Figure src="/images/user-guide/editor-send-revision.png" width="30%">
      Кнопка <q>Отправить правки</q>
    </Figure>
    <p>При желании Вы можете оставить дополнительное сообщение редактору, в открывшемся окне.</p>
    <p><b><i>После отправки правок функционал редактирования будет заблокирован.</i></b></p>

    <h3 id="part-6-8">6.8. Отправка комментария (рецензента)</h3>

    <p>По завершению рецензии &mdash; рецензент может использовать кнопку <q>Отправить рецензию</q> (в правом верхнем углу редактора) и описать текущее состояние рецензии.  После чего функционал рецензирования статьи будет заблокирован.</p>
    <p>После отправки рецензия будет зафиксирована в <a href="#article-hub">Хабе статьи</a></p>

    <p><b>Примечание:</b> комментарий рецензента видит только редактор.</p>

    <h2 id="intellichecker">7. IntelliChecker</h2>

    <p>IntelliChecker &mdash; это алгоритм, позволяющий проверить рукопись на соответствие формальным требованиям журнала.</p>
    <p>Например:</p>

    <ul>
      <li>В библиографическом описании приводятся фамилии авторов до трех, после чего, для отечественных публикаций следует указать <q>и др.</q>,
        для зарубежных <q>et al.</q></li>
      <li>У рисунка отсутствует подпись</li>
      <li>Межстрочный интервал не равен 1.5</li>
    </ul>

    <p>Полный список правил находится на странице сервиса.</p>

    <Figure src="/images/user-guide/sc-ic-fullscreen.png" width="100%">
      Сервис IntelliChecker
    </Figure>

    <h3 id="part-7-1">7.1. Расположение на сайте</h3>

    <Step n={1}>
      Наведите на раздел <q>Авторам</q> в навигационной панели
    </Step>

    <Figure src="/images/user-guide/sc-ic-navbar-1.png">
      Раздел <q>Авторам</q> навигационной панели
    </Figure>

    <Step n={2}>
      Выберите позицию <q>Проверить рукопись</q>
    </Step>

    <Figure src="/images/user-guide/sc-ic-navbar-2.png">
      Позиция <q>Проверить рукопись</q>
    </Figure>

    <h2 id="notifications">8. Уведомления</h2>

    <h3 id="part-8-1">8.1. Центр уведомлений</h3>

    <p>Чтобы открыть центр уведомлений, нажмите на значок рядом с аватаром (фото) пользователя (в&nbsp;верхнем&nbsp;правом углу страницы).</p>
    <p>Если у Вас есть непрочитанные уведомления &mdash; их количество будет отображено на кнопке.</p>

    <Figure src="/images/user-guide/notifications-open.png" width="20%">
      Кнопка для открытия центра уведомлений
    </Figure>

    <p>В центре уведомлений отображаются адресованные Вам уведомления, в порядке <q>новые - старые</q>.</p>

    <p>Каждое уведомление содержит:</p>
    <ul>
      <li>Название</li>
      <li>Описание</li>
      <li>Время получения (относительно текущего времени)</li>
    </ul>

    <p>При нажатии на карточку уведомления &mdash; Вы попадаете в соответствующую часть системы</p>
    <Figure src="/images/user-guide/notifications.png" width="70%">
      Центр уведомлений
    </Figure>

    <h3 id="part-8-2">8.2. Отключение отправки уведомлений на почту</h3>
    <Step n={1}>
      Откройте <a href="#settings">Настройки</a>
    </Step>
    <Step n={2}>
      Нажмите на <q>Отсылать уведомления на почту</q>
    </Step>
    <Step n={3}>
      Нажмите на <q>Сохранить</q>
    </Step>


    <h2 id="part-9">9. Директория проекта</h2>

    <p>Директория проекта содержит несколько загруженных или созданных Вами файлов.
      При нажатии на имя файла, он откроется в новой вкладке браузера.</p>

    <Figure src="/images/user-guide/project.png">
      Директория проекта
    </Figure>

    <h3 id="part-9-1">9.1. Форматы файлов</h3>

    <ul>
      <li>DOCX &mdash; прсомотр, редактирование и отправка в журнал</li>
      <li>XLSX &mdash; просмотр и редактирование</li>
      <li>Изображения (PNG, JPEG, WEBP) &mdash; просмотр</li>
    </ul>


    <h3 id="part-9-2">9.2. Создание файла</h3>

    <Step n={1}>Нажмите на <q>Новый файл</q></Step>
    <Step n={2}>Загрузите или создайте пустой файл</Step>
    <Step n={3}>Введите имя файла</Step>
    <Step n={3}>Нажмите на <q>Создать</q></Step>


    <Figure src="/images/user-guide/project-file-create.png" width="50%">
      Загрузка файла
    </Figure>

    <h3 id="part-9-3">9.3. Меню управления файлом</h3>

    <p>Для управления файлом &mdash; нажмите на кнопку напротив него.</p>

    <Figure src="/images/user-guide/project-file-menu.png" width="100%">
      Меню управления файлом
    </Figure>

    <p>Из этого меню Вы можете переименовать, закрепить или удалить выбранный файл.</p>

    <h3 id="review-project">9.4. Проект рецензента</h3>

    <p>По умолчанию проект рецензии содержит только поданную в журнал статью. Однако директория может также содержать файл <q>Рецензия</q>,{' '}
      который может создать редактор или рецензент, при наличии заранее заготовленного шаблона.</p>


    <Figure src="/images/user-guide/review-project.png" width="100%">
      Проект рецензии
    </Figure>

    <p><b>Примечание:</b> возможность создания файла рецензии и рецензирования через текстовый редактор будет доступна только после согласия на рецензирование (в <a href="#lk-reviews">Личном кабинете</a> или в <a href="#review-accept-deny">Текстовом редакторе</a>)</p>


    <h3 id="part-9-4-1">9.4.1. Создание файла рецензии</h3>

    <Step n={1}>Для создания файла рецензии, нажмите на кнопку <q>Создать файл рецензии</q></Step>
    <Step n={2}>Выберите наполнение файла рецензии</Step>

    <Figure src="/images/user-guide/review-project-create.png" width="50%">
      Окно создания файла рецензии
    </Figure>

    <p>При использовании шаблона будет также отображен список доступных Вам шаблонов. Управлять этим списком можно в <a href="#lk-templates">Личном кабинете</a>.</p>

    <h3 id="part-9-5">9.5. Проект редактора</h3>
    <p>В проекте редактора присутствуют файл статьи и файлы заполняемые рецензентами. Номер в названии файла рецензии соответствует идентификационному номеру рецензента в <a href="#article-hub-editor">Хабе статьи (вид редактора)</a>.</p>

    <h2 id="courses">10. Курсы</h2>

    <p>Система позволяет размещать и записываться на различного рода курсы.</p>
    <p>Для открытия списка курсов:</p>

    <Step n={1}>Выберите раздел <q>Ресурсы</q> в навигационной панели</Step>
    <Step n={2}>Выберите позицию <q>Курсы, вебинары, обучающие мероприятия</q></Step>

    <h3 id="part-10-1">10.1. Просмотр курса</h3>

    <p>Для просмотра отдельного курса &mdash; нажмите на его карточку.</p>
    <p>На странице курса будет отображено:</p>
    <ul>
      <li>Название курса</li>
      <li>Дата проведения, дата окончания</li>
      <li>Место проведения/ссылка</li>
      <li>Описание</li>
      <li>Автор (имя, биография)</li>
      <li>Содержание</li>
    </ul>

    <Figure src="/images/user-guide/course.png" width="70%">
      Окно создания файла рецензии
    </Figure>

    <h3 id="part-10-2">10.2. Запись на курс</h3>

    <Step n={1}>Откройте страницу курса</Step>
    <Step n={2}>Нажмите на <q>Записаться</q></Step>

    <p>Далее на указанную Вами при регистрации на почту придет приглашение, включающее:</p>
    <ul>
      <li>Название курса</li>
      <li>Место проведения/ссылку</li>
      <li>Дату проведения, дату окончания</li>
      <li>ICal файл для использования в электронных календарях</li>
    </ul>
    <p>При изменении курса Вам придет повторное приглашение.</p>


    <h3 id="part-10-3">10.3. Отмена записи</h3>

    <Step n={1}>Откройте страницу курса</Step>
    <Step n={2}>Нажмите на <q>Отменить запись</q></Step>

    <h2 id="journal">11. Панель управления журналом</h2>

    <p>Для открытия панели управления журналом:</p>

    <Step n={1}>Откройте <a href="#user-menu">Меню пользователя</a></Step>
    <Step n={2}>Выберите позицию <q>Журнал</q></Step>

    <h3 id="article-hub-editor">11.1. Запрос</h3>
    <p>При нажатии на название статьи, откроется <a href="article-hub">Хаб статьи</a>, с дополнительными возможностями:</p>
    <ol>
      <li>Управление статусом статьи</li>
      <li>Управление рецензентами</li>
      <li>Выбор шаблона рецензии</li>
      <li>Выбор выпуска (используется для группировки в списке запросов журнала)</li>
    </ol>

    <Figure src="/images/user-guide/journal-articlehub.png" width="70%">
      Хаб статьи (вид со стороны редактора)
    </Figure>

    <h4 id="part-11-1-1">11.1.1. Управление рецензентами</h4>

    <p>Изначально у статьи отсутствуют рецензенты. Для его назначения:</p>
    {/* TODO: reviewer add modal */}

    <Step n={1}>Нажмите на <q>Добавить рецензента</q></Step>
    <Step n={2}>Введите имя и фамилию / логин / почту пользователя</Step>
    <Step n={3}>Выберите результат из списка</Step>
    <Step n={4}>В открывшейся секции выберите срок рецензии</Step>
    <Step n={5}>Нажмите <q>Назначить</q></Step>

    <Figure src="/images/user-guide/articlehub-reviewer-add.png" width="70%">
      Секция для выбора срока рецензии
    </Figure>

    <p>Далее рецензент должен принять запрос в <a href="#lk-reviews">Личном кабинете</a> или в <a href="#review-accept-deny">Текстовом редакторе</a>.</p>

    <p>После принятия запроса рецензентом, редактору предоставляется три функциональных элемента для управления его доступом к статье:</p>

    <ol>
      <li>Принятие рецензии</li>
      <li>Блокировка рецензирования &mdash; позволяет заблокировать функционал рецензирования и комментирования в файле статьи</li>
      <li>Отстранение рецензента</li>
    </ol>

    <p>Под именем рецензента располагается его логин, номер и срок сдачи рецензии, указанный при назначении.</p>

    <Figure src="/images/user-guide/articlehub-reviewer.png" width="70%">
      Управление рецензентом
    </Figure>

    <h3 id="part-11-2">11.2. Вкладка <q>Запросы</q></h3>

    <p>Вкладка <q>Запросы</q> содержит активные запросы на проведение экспертизы.</p>

    <Figure src="/images/user-guide/journal.png" width="70%">
      Журнал &mdash; вкладка <q>Запросы</q>
    </Figure>


    <h4 id="part-11-2-1">11.2.1. Сортировка запросов</h4>

    <p>По умолчанию запросы сортируются по принципу <q>новое - старое</q>.
      Для изменения порядка сортировки, откройте меню управления сортировкой.</p>

    <Figure src="/images/user-guide/journal-requests-sort.png" width="70%">
      Меню сортировки
    </Figure>

    <h3 id="part-11-3">11.3. Вкладка <q>Архив</q></h3>

    <p>Вкладка <q>Архив</q> содержит архивированные запросы на проведение экспертизы.</p>
    <Figure src="/images/user-guide/journal-archive.png" width="70%">
      Журнал &mdash; вкладка <q>Архив</q>
    </Figure>

    <h3 id="part-11-4">11.4. Вкладка <q>Настройки</q></h3>

    {/* TODO: remove indexing */}

    <p>Вкладка <q>Настройки</q> позволяет редактору управлять информацией о журнале, в частности:</p>

    <ul>
      <li>Обложкой</li>
      <li>Названием</li>
      <li>Кратким описанием</li>
      <li>ISSN</li>
      <li>Индексированием</li>
      <li>Ссылками (на главную страницу и правила)</li>
    </ul>

    <Figure src="/images/user-guide/journal-settings.png" width="70%">
      Журнал &mdash; вкладка <q>Настройки</q>
    </Figure>

  </ContentPage>
}
